import { render, staticRenderFns } from "./DeductionsForm.vue?vue&type=template&id=6ef6c400&scoped=true&"
import script from "./DeductionsForm.vue?vue&type=script&lang=js&"
export * from "./DeductionsForm.vue?vue&type=script&lang=js&"
import style0 from "./DeductionsForm.vue?vue&type=style&index=0&id=6ef6c400&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ef6c400",
  null
  
)

export default component.exports